/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useMemo } from 'react';
import { PropertyCheckBox } from 'components/dropdowns/propertyCheckBox';
import { useWidgetParameter } from 'components/selectors/useWidgetParameter';

const valueFunction = (value) => !value;

/**
 * Allows for a true/false value with the given property name to be set in the widget configuration
 *
 * @param cardIndex
 * @param widgetConfiguration
 * @param propertyName
 * @param label
 * @returns {JSX.Element}
 * @constructor
 */
export const WidgetBooleanSelector = ({ cardIndex, widgetConfiguration, propertyName, label }) => {
	const currentValue = useMemo(() => {
		return !!widgetConfiguration?.[propertyName];
	}, [propertyName, widgetConfiguration]);

	const toggleProperty = useWidgetParameter({ propertyName, cardIndex, widgetConfiguration, valueFunction });

	return <PropertyCheckBox text={label} onChange={() => toggleProperty(currentValue)} checked={currentValue} />;
};
